import React from 'react'
import Login from './containers/login/Login'

const LoginPage = () => (
  <Login />
)

export default LoginPage


/** WEBPACK FOOTER **
 ** ./src/components/LoginPage.js
 **/